import { render, staticRenderFns } from "./ReviewModal.vue?vue&type=template&id=0e5b3bd7"
import script from "./ReviewModal.vue?vue&type=script&lang=js"
export * from "./ReviewModal.vue?vue&type=script&lang=js"
import style0 from "./ReviewModal.vue?vue&type=style&index=0&id=0e5b3bd7&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports